import { useEffect, useState } from 'react';
import { Button, Input } from '@mui/material';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { get_auth_user_data } from '../../redux/auth/auth.selectors';
import axiosInstance from '../../http-common';
import getErrorMessage from '../../util';
import SnackbarWithMessage from '../../common/components/Snackbars/SnackbarWithMessage';
import { CustomCheckbox } from '../../common/components/Checkbox/CustomCheckbox';
import RolesListSelectorBase from './RolesListSelectorBase';

const initial_user_state = {
  name: "",
  last_name: "",
  email: "",
  client_id: localStorage.getItem("client_id"),
  client_id_enabled: [],
  role: "viewer",
  application: "qc",
  roles_list: [],
  employee_id: "",
};

const AddUserDrawerComponent = ({ set_new_user_added = () => { } }) => {

  const admin_data = useSelector(get_auth_user_data);
  // console.log({ admin_data });
  // const [numberOfUsers,
  //   // setNumberOfUsers
  // ] = useState('1');
  // const [role, setRole] = useState('');
  const [plantAccess, setPlantAccess] = useState([]);

  // const handleRoleChange = (event) => {
  //   setRole(event.target.value);
  // };

  const handlePlantChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      setPlantAccess(prev => ([...prev, event?.target?.name]));
    } else {
      setPlantAccess(prev => prev?.filter(plant_name => plant_name !== event?.target?.name));
    }
  };

  const [plants,
    // set_plants
  ] = useState(admin_data?.client_id_enabled);

  const select_all_plants = () => { setPlantAccess([...plants]); };

  const [user, set_user] = useState({ ...initial_user_state });

  useEffect(() => {
    set_user(prev => ({
      ...prev,
      client_id_enabled: plantAccess,
      client_id: plantAccess?.[0],
    }));
  }, [plantAccess]);

  // const handleSubmit = () => {
  //   // Handle the submit action here
  //   console.log({
  //     numberOfUsers,
  //     role,
  //     plantAccess,
  //   });
  // };

  const handleCancel = () => {
    set_user({ ...initial_user_state });
  };

  const handleChange = (e) => {
    const { value, name } = e?.target;
    set_user((prev) => {
      const updated_user = {
        ...prev,
        [name]: value
      };
      if (name === "roles_list") {
        updated_user.role = value?.[0];
      }
      return updated_user;
    });
  };

  const [creating_user, set_creating_user] = useState(false);

  const create_user_promise = async () => {
    try {
      return axiosInstance.post(`/v1/user/`, user);
    } catch (error) {
      return getErrorMessage(error);
    }
  };

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const handleSubmit = async () => {
    try {
      set_creating_user(true);
      const response = await create_user_promise();
      const { message } = (await response)?.data;
      set_open_snackbar_with_message(prev => ({
        message,
        open: true,
        severity: "success",
      }));
      // console.log(user);
      set_new_user_added(true);
      // console.log(response);
    } catch (error) {
      const { data } = error?.response;
      const keys = Object.keys(data);
      const msg = `${keys[0]} - ${data[keys[0]]}`;
      set_open_snackbar_with_message(prev => ({
        message: msg,
        open: true,
        severity: "error",
      }));
      console.log(error);
    } finally {
      set_creating_user(false);
    }
  };


  return (
    <>
      <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
        set_open_snackbar_with_message({
          open: false,
          message: "",
          severity: "info"
        });
      }} />
      <div className="w-[348px] h-full p-6 bg-white rounded-tl-2xl rounded-bl-2xl flex-col justify-start items-start gap-6 inline-flex overflow-scroll">
        <div className="text-center text-neutral-700 text-lg font-medium font-['Roboto'] leading-normal tracking-tight">Add new user</div>
        <div className="w-[300px] grow shrink basis-0 flex-col justify-between items-start flex">
          <div className="flex-col justify-start items-start gap-7 flex">
            <div className="flex-col justify-start items-start gap-7 flex">
              <div className="flex-col justify-start items-start gap-3 flex">
                <div className="text-zinc-600 text-sm font-medium font-['Roboto']">First Name</div>
                <div className="w-[300px] h-10 relative">
                  <Input
                    type="text"
                    className="w-[300px] h-10 left-0 top-0 absolute rounded-[5px] border border-zinc-500 px-4"
                    placeholder='Enter Full Name'
                    name="name"
                    value={user?.name}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="flex-col justify-start items-start gap-3 flex">
                <div className="text-zinc-600 text-sm font-medium font-['Roboto']">Last Name</div>
                <div className="w-[300px] h-10 relative">
                  <Input
                    type="text"
                    className="w-[300px] h-10 left-0 top-0 absolute rounded-[5px] border border-zinc-500 px-4"
                    placeholder='Enter Full Name'
                    name="last_name"
                    value={user?.last_name}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="flex-col justify-start items-start gap-3 flex">
                <div className="text-zinc-600 text-sm font-medium font-['Roboto']">Employee ID</div>
                <div className="w-[300px] h-10 relative">
                  <Input
                    type="text"
                    className="w-[300px] h-10 left-0 top-0 absolute rounded-[5px] border border-zinc-500 px-4"
                    placeholder='Employee ID'
                    name="employee_id"
                    value={user?.employee_id}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="flex-col justify-start items-start gap-3 flex">
                <div className="justify-start items-start gap-2 inline-flex">
                  <div className="text-zinc-600 text-sm font-medium font-['Roboto']">Email ID</div>
                </div>
                <div className="w-[300px] h-10 relative">
                  <div className="w-[300px] h-10 left-0 top-0 absolute rounded-[5px] border border-zinc-500" />
                  <Input
                    type="email"
                    className="w-[300px] h-10 left-0 top-0 absolute rounded-[5px] border border-zinc-500 px-4"
                    placeholder='Enter Valid Email ID'
                    name="email"
                    value={user?.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="flex-col justify-start items-start gap-6 flex">
              <div className="flex-col justify-start items-start gap-3 flex">
                <div className="text-zinc-600 text-sm font-medium font-['Roboto']">Role</div>
                <div className="w-[300px] h-10 relative">
                  {/* <div className="w-[300px] h-10 left-0 top-0 absolute rounded-[5px] border border-zinc-500" /> */}
                  <RolesListSelectorBase change_handler={handleChange} selected_roles={user?.roles_list} />
                </div>
              </div>
              <div className="flex-col justify-start items-start gap-0 flex mt-4">
                <div className="text-zinc-600 text-sm font-medium font-['Roboto']">The user will have access to</div>
                <div className="flex-col justify-start items-start flex">
                  <div className="pr-3 py-2 justify-start items-center gap-3 inline-flex">
                    <CustomCheckbox checked={plantAccess?.length === plants?.length} onChange={(e) => {
                      const checked = e.target.checked;
                      if (checked) {
                        select_all_plants();
                      }
                      else {
                        setPlantAccess([]);
                      }

                    }} />
                    <div className="flex-col justify-start items-start inline-flex">
                      <div className="text-zinc-600 text-sm font-normal font-['Roboto'] leading-normal tracking-wide">All plants</div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-y-3">
                    {
                      plants?.map((plant_name, index) => <div key={`${plant_name}-${index}-add-plant-add-user`} className="h-10 pr-3 py-2 justify-start items-center gap-3 flex">
                        <CustomCheckbox key={`plant-name-${plant_name}-add-plant-for-user`} checked={plantAccess?.includes(plant_name)} onChange={handlePlantChange} name={plant_name} />
                        <div className="flex-col justify-start items-start inline-flex">
                          <div className="text-zinc-600 text-sm font-normal font-['Roboto'] leading-normal tracking-wide capitalize">{plant_name?.split("_")?.join(" ")}</div>
                        </div>
                      </div>)
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="justify-start items-center gap-2.5 inline-flex">
            <LoadingButton
              // className='!bg-blue-900 !text-white'
              variant='contained'
              loading={creating_user}
              onClick={handleSubmit}
              sx={{
                backgroundColor: "#2660B6",
                color: "white"
              }}
            >
              Save
            </LoadingButton>
            {/* <div className="w-[84px] px-4 py-2.5 bg-blue-900 rounded-lg justify-center items-center flex">
            <div className="px-2 justify-center items-center flex">
              <div className="text-center text-white text-base font-medium font-['Roboto'] leading-tight tracking-tight">Save</div>
            </div>
          </div> */}
            <Button className='' variant='outlined' onClick={handleCancel} >Cancel</Button>
            {/* <div className="h-10 px-3 py-1.5 rounded-lg border border-neutral-400 flex-col justify-center items-center gap-2.5 inline-flex">
            <div className="justify-start items-center gap-2 inline-flex">
              <div className="text-center text-zinc-600 text-sm font-medium font-['Roboto'] leading-tight tracking-tight">Discard</div>
            </div>
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUserDrawerComponent;
